//Cognito config for test environment
import { getCurEnv } from "./envVarsReader";

const testAuthConfig = {
    AppWebDomain: 'security-automation-cpe-dashboard-test.auth.us-west-1.amazoncognito.com',
    ClientId: 'i1bg73q4bfmbahv75ffa7nmis',
    RedirectUriSignIn: window.location.origin,
    RedirectUriSignOut: window.location.origin,
    TokenScopesArray: ['openid'],
    UserPoolId: 'us-west-1_fyNZFu7lO'
}

//Cognito config for prod environment
const prodAuthConfig = {
    AppWebDomain: 'security-automation-pann-dashboard.auth.us-west-2.amazoncognito.com',
    ClientId: '6qfpq49340nk6f0pklllhvektk',
    RedirectUriSignIn: window.location.origin,
    RedirectUriSignOut: window.location.origin,
    TokenScopesArray: ['openid'],
    UserPoolId: 'us-west-2_khTNarfOl'
}

const configAuthDir = {
    "test": testAuthConfig,
    "prod": prodAuthConfig,
}

export function getAuthConfig() {
    return configAuthDir[getCurEnv()];
}

export const cvePattern = /^CVE-\d{4}-\d{4,7}$/;